var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "navbar navbar-custom navbar-expand-lg" }, [
    _c(
      "ul",
      { staticClass: "navbar-nav mr-auto" },
      [
        _c(
          "router-link",
          { staticClass: "navbar-brand", attrs: { to: { name: "mainPage" } } },
          [
            _c("img", {
              staticClass: "responsive",
              staticStyle: { height: "60px" },
              attrs: { src: require("../assets/sith.png") }
            })
          ]
        ),
        _vm._v(" "),
        _vm._m(0)
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _vm._m(4)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navbarSupportedContent",
          "aria-controls": "navbarSupportedContent",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "border-right", staticStyle: { "padding-right": "5px" } },
      [
        _c("a", { attrs: { href: "https://www.australia.gov.au/" } }, [
          _c("img", {
            staticClass: "responsive",
            staticStyle: { height: "60px" },
            attrs: { src: require("../assets/ausgov.png") }
          })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "border-right",
        staticStyle: { "padding-right": "7px", "padding-left": "10px" }
      },
      [
        _c(
          "a",
          { attrs: { href: "https://www.nationalskillscommission.gov.au/" } },
          [
            _c("img", {
              staticClass: "responsive",
              staticStyle: { height: "60px" },
              attrs: { src: require("../assets/nsc.png") }
            })
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "border-right",
        staticStyle: { "padding-right": "7px", "padding-left": "10px" }
      },
      [
        _c("a", { attrs: { href: "https://aristotlemetadata.com" } }, [
          _c("img", {
            staticClass: "responsive",
            staticStyle: { height: "60px" },
            attrs: { src: require("../assets/bigaris.png") }
          })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { "padding-right": "7px", "padding-left": "10px" } },
      [
        _c("a", { attrs: { href: "https://govhack.org" } }, [
          _c("img", {
            staticClass: "responsive",
            staticStyle: { height: "60px" },
            attrs: { src: require("../assets/govhack.png") }
          })
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }